import { ApolloClient, InMemoryCache } from "@apollo/client"
import { createUploadLink } from "apollo-upload-client";
import fetch from "node-fetch"
import { setContext } from "apollo-link-context"
import { parseCookies } from "nookies"

const link = createUploadLink({
  uri: process.env.NEXT_PUBLIC_SERVER_URI,
  fetch: fetch
})

const authLink = setContext((_, { headers }) => {
  const { token } = parseCookies()

  if (!token)
    return {}

  return {
    headers: {
      ...headers,
      authorization: token ? token : ""
    }
  }
})

const getClient = () => {
  return new ApolloClient({
    link: authLink.concat(link),
    cache: new InMemoryCache({
      addTypename: false
    })
  })
}

export const graphqlApolloClient = getClient()